"use client"

import { useEffect, useState } from "react"
import dynamic from "next/dynamic"
import { useSearchParams } from "next/navigation"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { getSbLocaleFromMarket, isSupportedMarket } from "@/lib/market/market"
import { BottomRightPopupClient } from "@/components/dialog/BottomRightPopupClient"

const InitialCustomerTypeDialogClient = dynamic(
  () => import("../dialog/InitialCustomerTypeDialogClient.js").then((mod) => mod.default),
  { ssr: false }
)

interface StorefrontContextResponse {
  isB2B: boolean
  oci: boolean
}

function getSbLocaleFromCurrentMarketPath() {
  if (typeof window === "undefined") {
    return undefined
  }

  const [, marketPrefix, market] = window.location.pathname.split("/")
  if (marketPrefix === "m" && isSupportedMarket(market)) {
    return getSbLocaleFromMarket(market)
  }

  return undefined
}

export default function LayoutRequestGatesClient() {
  const searchParams = useSearchParams()
  const { setIsB2BCustomer, setIsOCI } = useUbStorefrontState()
  const [oci, setOci] = useState(false)

  useEffect(() => {
    let cancelled = false
    const sbLocale = getSbLocaleFromCurrentMarketPath()
    const contextUrl = sbLocale
      ? `/api/storefront/context?sbLocale=${encodeURIComponent(sbLocale)}`
      : "/api/storefront/context"

    fetch(contextUrl, {
      cache: "no-store",
    })
      .then((response) => (response.ok ? response.json() : undefined))
      .then((context: StorefrontContextResponse | undefined) => {
        if (!cancelled && context) {
          setOci(context.oci)
          setIsOCI(context.oci)
          setIsB2BCustomer(context.isB2B)
        }
      })
      .catch(() => undefined)

    return () => {
      cancelled = true
    }
  }, [setIsB2BCustomer, setIsOCI])

  if (oci) {
    return null
  }

  return (
    <>
      {!searchParams.has("_storyblok") && <InitialCustomerTypeDialogClient />}
      <BottomRightPopupClient />
    </>
  )
}
